import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { round, toInteger } from 'lodash';

import {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';

import * as Yup from 'yup';

import * as S from './styles';

import { isEmpty, find } from 'lodash';

import { SelectDataInTable } from '~/components';


export default function DadosEstoque({ data }) {

  const cellsEstoque = React.useMemo(
    () => [
      { id: 'tafi_nome', label: 'Tanque' },
      { id: 'prod_descricao', label: 'Produto' },
      { id: 'tafi_capacidade', label: 'Capacidade' },
      { id: 'tafi_volume_cont', label: 'Estoque', format: (value) => toInteger(value).toLocaleString('pt-br') },
      { id: 'tafi_limit_baixo', label: 'Ponto Ressuprimento', format: (value) => toInteger(value).toLocaleString('pt-br') },
    ],
    []
  );

  const [camposEstoque, setCamposEstoque] = useState([]);

  // cotas veiculo

  const [estoques, setEstoques] = useState(data.tanquesFisicos);
  const [capacidade, setCapacidade] = useState(0)
  const [estoquesTanque, setEstoquesTanque] = useState([]);
  const [todosEstoques, setTodosEstoques] = useState([]);

  React.useEffect(() => {
    let etqs = [];
    if (estoques) {
      estoques.map((value) => {
        etqs.push({
          id: value.tafi_nome,
          label: value.prod_descricao,
          value: value.tafi_nome,
          tafi_codigo: value.tafi_codigo,
          tavi_codigo: value.tavi_codigo,
          poco_codigo: data.posto.poco_codigo,
          tafi_capacidade: value.tafi_capacidade,
          tafi_volume_cont: value.tafi_volume_cont,
          tafi_limit_baixo: value.tafi_limit_baixo,
          ...value,
        });
      });



    }
    setEstoquesTanque(etqs);
  }, [estoques]);

  // atualiza com a edicao

  function handleAtualizaEstoque(estqs) {
    let etqs = [];
    let erro = false;
    if (estqs) {
      estqs.map((value) => {
        if (value.tafi_limit_baixo > value.tafi_capacidade) {
          erro = true;
        }
        etqs.push({
          tafi_nome: value.id,
          prod_descricao: value.label,
          tafi_codigo: value.tafi_codigo,
          tavi_codigo: value.tavi_codigo,
          poco_codigo: data.posto.poco_codigo,
          tafi_capacidade: value.tafi_capacidade,
          tafi_volume_cont: value.tafi_volume_cont,
          tafi_limit_baixo: value.tafi_limit_baixo,
        });
      });
    }
    data.tanquesFisicos = etqs;
    data.erroEstoque = erro;
  }

  function handleEdicaoCampos(value) {

    // configura campos apos a edicao - verifica se inclusao ou alteracao
    let tafi_codigo = null;
    let tavi_codigo = null;
    let poco_codigo = data.posto.poco_codigo;
    let prod_descricao = null;
    let tafi_capacidade = null;
    let tafi_volume_cont = null;
    let tafi_limit_baixo = null;
    if (estoquesTanque) {
      estoquesTanque.map((etq) => {
        if (etq.tafi_nome === value.tafi_nome) {
          tafi_codigo = etq.tafi_codigo;
          tavi_codigo = etq.tavi_codigo;
          prod_descricao = etq.prod_descricao;
          tafi_capacidade = etq.tafi_capacidade;
          tafi_volume_cont = etq.tafi_volume_cont;
          tafi_limit_baixo = value.tafi_limit_baixo; // valor
          setCapacidade(value.tafi_capacidade)
        }
      }, []);
    }
    return {
      ...value,
      id: value.tafi_nome,
      label: value.prod_descricao,
      value: value.tafi_nome,
      tafi_codigo: tafi_codigo,
      tavi_codigo: tavi_codigo,
      poco_codigo: poco_codigo,
      prod_descricao: prod_descricao,
      tafi_capacidade: tafi_capacidade,
      tafi_volume_cont: tafi_volume_cont,
      tafi_limit_baixo: tafi_limit_baixo,
    };
  }

  // todos os estoques

  React.useEffect(() => {
    if (!isEmpty(data)) {
      setTodosEstoques(data.tanquesFisicos);
    }
  }, [data]);

  React.useEffect(() => {
    // configura os campos de edicao

    let camposEstoque = [
      {
        id: 'tafi_codigo',
        type: 'text',
        label: 'Físico',
        options: [],
        disabled: true,
      },
      {
        id: 'tavi_codigo',
        type: 'text',
        label: 'Virtual',
        options: [],
        disabled: true,
      },
      {
        id: 'tafi_nome',
        type: 'text',
        label: 'Nome do Tanque',
        options: [],
        disabled: true,
      },
      {
        id: 'prod_descricao',
        type: 'text',
        label: 'Produto',
        options: [],
        disabled: true,
      },
      {
        id: 'tafi_capacidade',
        type: 'text',
        label: 'Capacidade',
        options: [],
        disabled: true,
      },
      {
        id: 'tafi_limit_baixo',
        type: 'number',
        label: 'Ponto Ressuprimento',
        options: [],
      },
    ];

    setCamposEstoque(camposEstoque);
  }, [todosEstoques]);


  return (
    <>
      <S.ConteinerTab>
        <ExpansionPanelSummary
          aria-controls="panel4a-content"
          id="panel4a-header"
          style={{
            background: 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0,0,0,.2)',
          }}
        >
          <Typography>Tanques</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div style={{ width: '100%' }}>
            <SelectDataInTable
              noCreate
              noRemove
              cells={cellsEstoque}
              items={todosEstoques}
              fields={camposEstoque}
              initials={
                estoques
                  ? estoques.map((value) => ({
                    id: value.tafi_nome,
                    label: value.prod_descricao,
                    value: value.tafi_nome,
                    tafi_codigo: value.tafi_codigo,
                    tavi_codigo: value.tavi_codigo,
                    poco_codigo: data.posto.poco_codigo,
                    tafi_capacidade: value.tafi_capacidade,
                    tafi_volume_cont: value.tafi_volume_cont,
                    tafi_limit_baixo: value.tafi_limit_baixo,
                    ...value,
                  }))
                  : []
              }
              label="Tanques"
              onChanged={(values) => handleAtualizaEstoque(values)}
              unique="tafi_nome"
              onField={(value) => handleEdicaoCampos(value)}
              onOpenForm={(value) => setCapacidade(value.tafi_capacidade)}
              schema={{
                tafi_limit_baixo: Yup.number()
                  .required().min(0, 'A quantidade mínima é 0')
                  .max(capacidade - 1, `A quantidade máxima é ${capacidade - 1}`)
              }}
            />
          </div>
        </ExpansionPanelDetails>
      </S.ConteinerTab>
    </>
  );
}
